import { render } from "./myAssesment.vue?vue&type=template&id=1a1aa3d0&scoped=true"
import script from "./myAssesment?vue&type=script&lang=js"
export * from "./myAssesment?vue&type=script&lang=js"

import "./myAssesment.vue?vue&type=style&index=0&id=1a1aa3d0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1aa3d0"]])

export default __exports__